import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import _ from 'lodash';

export function ReportLandingRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.ReportLanding', {
		url: '/analytics',
		controllerAs: 'vm',
		controller: ReportLandingCtrl,
		templateUrl: '/ng/hub/Report/Landing/ReportLandingCtrl.html?' + window.BUILD,
		permission: ['manage_users'],
		resolve: {
			reports: ApiResourcify.endpoint('/analytics/reports/list'),
			style: () => AssetManager.css('/ng/hub/Report/Landing/ReportLandingCtrl.css'),
			$title: () => 'Analytics',
		},
	});
}

export class ReportLandingCtrl {
	constructor(reports) {
		'ngInject';
		this.allReports = reports;
		this.filteredReports = reports;
		this.filterNone = 'Filter by report type';
		this.reportType = this.filterNone;
		this.reportTypes = _.uniq(_.map(reports, 'type')).sort();
		this.reportTypes.unshift(this.filterNone);
		this.reportTypes = this.reportTypes.map(name => ({ id: name, name }));
		this.breadcrumbs = [
			{ label: 'Admin', url: '/hub#/admin/users' },
			{ label: 'Analytics', url: null },
		];
	}

	filterReports() {
		if (this.reportType === this.filterNone) {
			this.filteredReports = this.allReports;
		} else {
			this.filteredReports = this.allReports.filter(r => r.type === this.reportType);
		}
	}
}
